<script>
    import {createEventDispatcher} from 'svelte';

    const dispatch = createEventDispatcher();

    // Входные данные
    export let items = []; // Список объектов {id, name}
    export let defaults = null;
    export let placeholder = "Поиск...";

    let searchQuery = items.find(({idUrllico}) => idUrllico === defaults)?.name ?? '';
    let isOpen = false;
    let selectedName = "";

    // Фильтрация списка на лету
    $: filteredItems = items.filter(item =>
        item.name?.toLowerCase()?.includes(searchQuery.toLowerCase())
    );

    function selectItem(item) {
        selectedName = item.name;
        searchQuery = item.name; // Заполняем поле выбранным текстом
        isOpen = false;

        // Отправляем ID наверх родителю
        dispatch('select', {id: item.idUrllico});
    }

    function handleInput() {
        isOpen = true;
        if (searchQuery === "") {
            dispatch('select', {id: null});
        }
    }
</script>

<div class="wrapper">
    <input
        type="text"
        class="form-control"
        {placeholder}
        bind:value={searchQuery}
        on:input={handleInput}
        on:focus={() => (isOpen = true)}
        on:blur={() => setTimeout(() => (isOpen = false), 200)}
    />

    {#if isOpen && filteredItems.length > 0}
        <ul class="dropdown">
            {#each filteredItems as item}
                <li on:click={() => selectItem(item)}>
                    {item.name}
                </li>
            {/each}
        </ul>
    {/if}
</div>

<style>
    .wrapper {
        position: relative;
    }

    .dropdown {
        position: absolute;
        top: 100%;
        left: 0;
        right: 0;
        background: white;
        border: 1px solid #ccc;
        border-top: none;
        list-style: none;
        padding: 0;
        margin: 0;
        max-height: 200px;
        overflow-y: auto;
        z-index: 10;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    }

    li {
        padding: 8px;
        cursor: pointer;
    }

    li:hover {
        background-color: #f0f0f0;
    }
</style>
